import type { ReactNode } from 'react'
import { CallWindowSizeIcon } from './CallWindowSizeIcon'
import { UserChatSummaryEntry } from './UserChatSummaryEntry'

interface CallSurfaceTopBarProps {
  compact: boolean
  center?: ReactNode
  summaryUserID?: string
  className?: string
  onToggleCompact: () => void
}

export function CallSurfaceTopBar({
  compact,
  center,
  summaryUserID,
  className,
  onToggleCompact,
}: CallSurfaceTopBarProps) {
  return (
    <div className={`call-surface-top${className ? ` ${className}` : ''}`}>
      <button
        className="call-surface-icon-button"
        type="button"
        aria-label={compact ? 'Expand video' : 'Minimize video'}
        onClick={onToggleCompact}
      >
        <CallWindowSizeIcon compact={compact} />
      </button>
      <div className="call-surface-top-center">{center}</div>
      <UserChatSummaryEntry
        className="call-surface-icon-button call-surface-summary-button"
        userID={summaryUserID}
      />
    </div>
  )
}
